// Carries the one-time signin nonce across the Lemon Squeezy redirect.
// URL params can't be trusted to make the round trip (LS drops most of
// them), so we stash the nonce in localStorage before redirecting and
// read it back on /success.

const KEY = 'sun-calendar:pending-purchase';
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

interface PendingPurchase {
  email: string;
  nonce: string;
  ts: number;
}

export function savePendingPurchase(email: string, nonce: string): void {
  const payload: PendingPurchase = { email, nonce, ts: Date.now() };
  try {
    localStorage.setItem(KEY, JSON.stringify(payload));
  } catch {
    /* private-mode Safari throws on write — no-op is fine */
  }
}

export function readPendingPurchase(): PendingPurchase | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PendingPurchase;
    if (!parsed.nonce || !parsed.email) return null;
    if (Date.now() - parsed.ts > MAX_AGE_MS) {
      clearPendingPurchase();
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearPendingPurchase(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* no-op */
  }
}
